"use client"

// Molecules
import { Badge } from "../../../../Molecules/Badge"

// Components
import { MediaObject } from "@/types/centra/checkout-api/products/post-products"
import QuickShopImageCarousel from "../QuickShopImageCarousel"

type QuickShopImageGalleryProps = {
    images: MediaObject[]
    badges: string[]
    isProductAvailable?: boolean
    prodctName: string
}

export default function QuickShopImageGallery({
    images,
    badges,
    prodctName
}: QuickShopImageGalleryProps) {
    return (
        <div className="relative h-full gap-24">
            {badges.map((badge, index) => (
                <div className="absolute z-[5] flex" key={index}>
                    <div key={index}>
                        <Badge badge={badge} />
                    </div>
                </div>
            ))}
            <QuickShopImageCarousel
                images={images.map(image => image?.sources ?? "")}
                selectedImage={0}
                productName={prodctName}
            />
        </div>
    )
}
